const MODULE_STATUS_LABELS: Record<string, string> = {
  auto_map_hunt_entry_no_continent_stone: "入口缺少大陆传送石，已转挑战BOSS兜底",
};

const MATRIX_COLOR_LABELS: Record<string, string> = {
  green: "运行正常",
  yellow: "待确认",
  red: "异常",
  gray: "未运行/未上报",
};

const RUNTIME_STATUS_LABELS: Record<string, string> = {
  running: "运行中",
  stopped: "已停止",
  error: "异常",
  warn: "注意",
  unreported: "未上报",
};

const CONFIG_DRIFT_LABELS: Record<string, string> = {
  clean: "一致",
  none: "一致",
  ignored: "已忽略",
  pending_review: "待确认",
  unreported: "未上报",
};

const MODULE_SCOPE_LABELS: Record<string, string> = {
  machine: "机器",
  game: "游戏",
  account: "账号",
  instance: "实例",
};

export function formatModuleRuntimeStatus(status: string | null | undefined): string {
  const text = String(status ?? "");
  if (text === "") return "";
  const normalized = text.trim();
  const label = RUNTIME_STATUS_LABELS[normalized] ?? normalized;
  return label.replace(
    /\bauto_map_hunt_entry_no_continent_stone\b/g,
    MODULE_STATUS_LABELS.auto_map_hunt_entry_no_continent_stone,
  );
}

export function formatModuleMatrixColor(color: string | null | undefined): string {
  const key = String(color ?? "").trim();
  if (key === "") return "";
  return MATRIX_COLOR_LABELS[key] ?? key;
}

export function formatModuleConfigDrift(drift: string | null | undefined): string {
  const key = String(drift ?? "").trim();
  if (key === "") return "";
  return CONFIG_DRIFT_LABELS[key] ?? key;
}

export function formatModuleDesiredEnabled(enabled: boolean | null | undefined): string {
  return enabled ? "启用" : "停用";
}

export function formatModuleReportedEnabled(
  enabled: boolean | null | undefined,
  runtimeStatus: string | null | undefined,
): string {
  return String(runtimeStatus ?? "").trim() === "unreported"
    ? "未上报"
    : formatModuleDesiredEnabled(enabled);
}

export function formatModuleScope(scope: string | null | undefined): string {
  const key = String(scope ?? "").trim();
  if (key === "") return "";
  return MODULE_SCOPE_LABELS[key] ?? key;
}
